import React from 'react'
import EventManager from "../../../../services/EventManager";
import { useTranslation } from '../../../../contexts/TranslationProvider';
import '../buttons.scss'

const SaveProjectTemplate = () => {
    const { t } = useTranslation();
    const handleSaveProjectTemplate = async () => {
        EventManager.invoke('saveProjectTemplate', true)
    };
    return (
        <button className="navbar-button" onClick={handleSaveProjectTemplate}>
            {t("navbar.saveProjectTemplate")}
        </button>
    )
}

export default SaveProjectTemplate